import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex)

//数据初始化
const state = {
    msg: ''
}

//中间层
const mutations = {
    saveMsg(state,msg) {
       state.msg = msg;
    }
}

//注册
export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})


// WEBPACK FOOTER //
// ./src/vuex/store.js